import { clsx } from 'clsx';
import { ReactNode, useEffect, useRef, useState } from 'react';
import {
  SlickBottomSheet,
  SlickBottomSheetControl,
} from './slick-bottom-sheet';

const WebBottomSheet = ({
  children,
  onClose,
  snapPoints,
  isOpen = true,
  backgroundColor = '#0C1C2C',
  dismissable = true,
  initialSnapPosition = undefined,
  footerContent,
  blurEnabled = false,
}: {
  children: ReactNode;
  onClose?: () => void;
  snapPoints?: (number | string)[];
  isOpen?: boolean;
  backgroundColor?: string;
  dismissable?: boolean;
  initialSnapPosition?: number;
  footerContent?: ReactNode;
  blurEnabled?: boolean;
}) => {
  const bottomSheetRef = useRef<SlickBottomSheetControl>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  // We create some internal state to make it behave in a similar way than the native one
  const [isOpenInternal, setIsOpenInternal] = useState(isOpen);
  useEffect(() => {
    setIsOpenInternal(isOpen);
  }, [isOpen]);

  // Map percentage strings to decimal numbers
  const snaps = (snapPoints ?? [])
    .map((s) => (typeof s == 'string' ? percentageToRatio(s) : s))
    .sort();

  const defaultSnap = snapPoints != null ? initialSnapPosition : undefined;

  return (
    <SlickBottomSheet
      isOpen={isOpenInternal}
      onCloseStart={() => {
        if (dismissable) {
          setIsOpenInternal(false);
          onClose?.();
        }
      }}
      ref={bottomSheetRef}
      snaps={snaps}
      defaultSnap={defaultSnap}
      autoSnapAsMax={false}
      maxSnapAsMax={false}
      useAutoSnap={true}
      allowScroll={false}
      className="rounded-t-2xl overflow-hidden shadow-xl z-50 isolate"
      style={{ backgroundColor }}
      header={
        <div className="flex justify-center h-6 items-center">
          <div className="w-10 h-1 rounded-full bg-[#465480]" />
        </div>
      }
      footer={
        <div style={{ backgroundColor }} className="flex-1 h-full">
          {footerContent}
        </div>
      }
      backdropClassName={clsx({
        'backdrop-blur-sm z-50': blurEnabled,
      })}
    >
      <div ref={contentRef}>{children}</div>
    </SlickBottomSheet>
  );
};

function percentageToRatio(percentage: string) {
  return (
    Number.parseFloat(percentage.substring(0, percentage.length - 1)) / 100
  );
}

export default WebBottomSheet;
